import { render, staticRenderFns } from "./chunkUpload.vue?vue&type=template&id=4b3086ec&scoped=true"
import script from "./chunkUpload.vue?vue&type=script&lang=js"
export * from "./chunkUpload.vue?vue&type=script&lang=js"
import style0 from "./chunkUpload.vue?vue&type=style&index=0&id=4b3086ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3086ec",
  null
  
)

export default component.exports